@if (orderSelected()) {
  <div class="order-shipment-details-container">   
    <!-- Only show information if we have loaded data-->
    @if (!isLoadingOrderDetails() && orderShipment != null && !orderDetailsHasErrorsLoading()) {
      <order-shipment-details-header [orderShipment]="orderShipment"></order-shipment-details-header>

      <div class="flex-layout view-container">
        <!-- content information on the left side of the view header-->
        <div class="left-side">
          @if (allowsAnyShipmentResets() && !resetRunning()) {
            <button matButton="filled" color="secondary" [matMenuTriggerFor]="resetShipmentMenu">
              <mat-icon>autorenew</mat-icon>
              <span>Reset Shipment To ⏷</span>
            </button>
            <mat-menu #resetShipmentMenu="matMenu">
              @if (canReset(ShipmentResetType.StreamingShipmentForBurning)) {
                <button mat-menu-item (click)="resetShipment(ShipmentResetType.StreamingShipmentForBurning)">Burning (Streaming)</button>
              }

              @if (canReset(ShipmentResetType.CinelinkShipmentForBurning)) {
                <button mat-menu-item (click)="resetShipment(ShipmentResetType.CinelinkShipmentForBurning)">Burning (Cinelink)</button>
              }

              @if (canReset(ShipmentResetType.AdebsDriveShipmentForBurning)) {
                <button mat-menu-item (click)="resetShipment(ShipmentResetType.AdebsDriveShipmentForBurning)">Burning (ADEBS Drive Shipment)</button>
              }

              @if (canReset(ShipmentResetType.AdebsDriveShipmentForEncryption)) {
                <button mat-menu-item (click)="resetShipment(ShipmentResetType.AdebsDriveShipmentForEncryption)">Encryption (ADEBS Drive Shipment)</button>
              }
            </mat-menu>
          }

          @if (resetRunning()) {
            <insight-loading-spinner [loadingMessage]="'Running Reset...'">
            </insight-loading-spinner>
          }

          @if (showHardDriveBurningErrorMessage()) {
            <span class="error-burning">
              <span>Error burning contents to hard drive</span>
            </span>
          }

          <!-- Order is complete -->
          @if (!isShipmentCancelled() && isAnyCompletedOrder()) {
            <div class="completed-order-section">
              <!-- variations of how to download metadata (if possible) -->
              <!-- Cinelink doesn't have manifest file. We do have a code path in C# to do it, but it is having issues
                  and it was decided it is better to just hide it for now. The Swank.Common.HardDrive (C#) upgraded on the new
                  Insight which could have broken it. -->
              @if (isMediaTypeCVD()) {
                <span class="completed-order-section-item">
                  <strong class="order-complete">Order Complete</strong>
                  <em class="order-complete-description">CVDs do not have metadata to download</em>
                </span>
              } @else if (isCompletedCinelinkOrder()) {
                <span class="completed-order-section-item">
                  <strong class="order-complete">Order Complete</strong>
                  <em class="order-complete-description">Cinelink orders have no metadata to download</em>
                </span>
              } @else {
                <strong class="order-complete">Order Complete</strong>
                <download-metadata-button [orderShipment]="orderShipment"></download-metadata-button>
              }
            </div>
          }

          <div class="order-controls">
            @if (isShipmentCancelled()) {
              <strong class="order-status">Order Cancelled</strong>
            }

            <!-- order is incomplete. Give ability to filter lines to just see errors -->
            <form [formGroup]="orderLinesFormGroup">
              <mat-checkbox formControlName="viewOnlyErrorsCheckbox">Only Line Errors</mat-checkbox>
            </form>
          </div>
        </div>

         <!-- change view type controls -->
        <div class="view-button-container">
          <button class="view-button" matTooltip="Grid View"
            [attr.active-view]="orderControllerService.orderDetailsViewType() === orderDetailViewEnum.Grid"
            mat-stroked-button
            (click)="orderControllerService.setOrderDetailsViewType(orderDetailViewEnum.Grid)"
            routerLinkActive="active-view">
            <mat-icon class="m-0">grid_on</mat-icon>
          </button>
          <button class="view-button"  matTooltip="Board View"
            [attr.active-view]="orderControllerService.orderDetailsViewType() === orderDetailViewEnum.Board"
            mat-stroked-button
            (click)="orderControllerService.setOrderDetailsViewType(orderDetailViewEnum.Board)"
            routerLinkActive="active-view">
            <mat-icon class="m-0">view_kanban</mat-icon>
          </button>
          <button class="view-button"  matTooltip="Timeline View" 
            [attr.active-view]="orderControllerService.orderDetailsViewType() === orderDetailViewEnum.Timeline"
            mat-stroked-button
            (click)="orderControllerService.setOrderDetailsViewType(orderDetailViewEnum.Timeline)"
            routerLinkActive="active-view">
            <mat-icon class="m-0">view_timeline</mat-icon>
          </button>
        </div>
      </div>

      @if (filteredOrderShipment()) {
        @if (noLinesToShow) {    
          <!-- message if there are no lines to show (probably because of filtering)-->        
          <em>No order lines to show.</em>
        } @else {
          @if (orderControllerService.orderDetailsViewType() === orderDetailViewEnum.Grid) {
            <insight-order-shipment-details-grid [orderShipment]="filteredOrderShipment()" ></insight-order-shipment-details-grid>
          }

          @if (orderControllerService.orderDetailsViewType() === orderDetailViewEnum.Board) {
            <insight-order-shipment-details-board [orderShipment]="filteredOrderShipment()"></insight-order-shipment-details-board>
          }

          @if (orderControllerService.orderDetailsViewType() === orderDetailViewEnum.Timeline) {
            <insight-order-shipment-details-timeline [orderShipment]="filteredOrderShipment()"></insight-order-shipment-details-timeline>
          }
        }
      } 
    }      
    
    <!-- We have an order to load it's information...but waiting for the data to come back -->
    @if (isLoadingOrderDetails()) {
      <content-loader [foregroundColor]="'#ddd'" [backgroundColor]="'#eee'" [viewBox]="'0 0 800 400'">
        <svg:rect x="0" y="0" rx="3" ry="3" width="100%" height="30" />
        <svg:rect x="0" y="40" rx="3" ry="3" width="80%" height="10" />
        <svg:rect x="0" y="60" rx="3" ry="3" width="20%" height="100" />
        <svg:rect x="200" y="60" rx="3" ry="3" width="20%" height="100" />
        <svg:rect x="420" y="60" rx="3" ry="3" width="20%" height="100" />
        <svg:rect x="630" y="60" rx="3" ry="3" width="20%" height="100" />
        <svg:rect x="0" y="180" rx="3" ry="3" width="100%" height="200" />
      </content-loader>
    }

    <!-- The order and shipment do not exist in the source system -->
    @if (orderDetailsNotFound()) {
      <div class="order-not-found">
        <h3>Order #{{requestedShipment()?.orderNumber}}:{{requestedShipment()?.shipmentNumber}} was not found</h3>
        <p>Check the order number and shipment number. The order may not have been entered yet, or it may belong to the other source system.</p>
        <ul class="error-messages">
          @for (message of errorMessages(); track message) {
            <li><em>{{ message }}</em></li>
          }
        </ul>
      </div>
    }

    <!-- There was some error loading the order -->
    @if (orderDetailsHasErrorsLoading()) {
      <div class="order-error">
        <h3>There was an issue loading order #{{requestedShipment()?.orderNumber}}:{{requestedShipment()?.shipmentNumber}}</h3>
        <p>Check the order number and shipment and verify it is correct. This is the error message from the server:</p>
        <ul class="error-messages">
          @for (message of errorMessages(); track message) {
            <li><em>{{ message }}</em></li>
          }
        </ul>
      </div>
    }
  </div>
} @else {
  <!-- There is nothing selected -->
  <div class="m-6 text-center">
    <em>No order details to show</em>
  </div>
}
